import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { graph } from '../system/environment/Config.json'
import { RootState } from '../store'
import { TotpSessionKey } from '../shared/Constants'

const fetchBaseGraphApiQuery = fetchBaseQuery({
  baseUrl: graph.api.baseurl,
  prepareHeaders: async (headers: Headers, api) => {
    headers.append('Content-Type', 'application/json')
    headers.append('cache-control', 'no-cache')
    const state = api.getState() as RootState
    if (state.app.totpSessionKey) {
      headers.append(TotpSessionKey, state.app.totpSessionKey)
    }

    return headers
  }
})

const GraphApiSlice = createApi({
  reducerPath: '@api/graph',
  baseQuery: fetchBaseGraphApiQuery,
  endpoints: () => ({}),
  tagTypes: ['CollaborationItemList']
})

export default GraphApiSlice
